import { useState } from 'react'
import { useRouter } from 'next/router'
import { useWishlist } from './use-wishlist'
import { UPDATE_PRODUCTS_IN_WISHLIST } from '../graphql/updateProductsInWishlist'
import { graphqlFetch, GraphqlFetchOutput } from '@pylot-data/graphqlFetch'
import {
    MutationUpdateProductsInWishlistArgs,
    UpdateProductsInWishlistOutput
} from '@pylot-data/pylotschema'

export interface OutputInterface {
    updateProductsInWishlist: UpdateProductsInWishlistOutput
}

export interface UseUpdateProductsInWishlistInterface {
    isLoading: boolean
    updateProductsInWishlist: (
        formInput: MutationUpdateProductsInWishlistArgs
    ) => Promise<GraphqlFetchOutput<OutputInterface>>
}

export const useUpdateProductsInWishlist = (): UseUpdateProductsInWishlistInterface => {
    const [isLoading, setIsLoading] = useState(false)
    const { locale } = useRouter()
    const { mutate } = useWishlist()

    const updateProductsInWishlist = async (
        formInput: MutationUpdateProductsInWishlistArgs
    ) => {
        setIsLoading(true)

        const response = await graphqlFetch<
            MutationUpdateProductsInWishlistArgs,
            OutputInterface
        >({
            query: UPDATE_PRODUCTS_IN_WISHLIST,
            variables: formInput,
            locale
        })

        await mutate()
        setIsLoading(false)
        return response
    }

    return {
        isLoading,
        updateProductsInWishlist
    }
}
